"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandler = void 0;
const router_1 = require("@keplr-wallet/router");
const messages_1 = require("./messages");
const getHandler = (service) => {
    return (env, msg) => {
        switch (msg.constructor) {
            case messages_1.GetAutoLockAccountDurationMsg:
                return handleGetAutoLockAccountDurationMsg(service)(env, msg);
            case messages_1.UpdateAutoLockAccountDurationMsg:
                return handleUpdateAutoLockAccountDurationMsg(service)(env, msg);
            case messages_1.StartAutoLockMonitoringMsg:
                return handleStartAutoLockMonitoringMsg(service)(env, msg);
            default:
                throw new router_1.KeplrError("auto-lock-account", 100, "Unknown msg type");
        }
    };
};
exports.getHandler = getHandler;
const handleGetAutoLockAccountDurationMsg = (service) => {
    return () => {
        return service.getAutoLockDuration();
    };
};
const handleUpdateAutoLockAccountDurationMsg = (service) => {
    return (_, msg) => {
        if (!service.keyRingIsUnlocked) {
            throw new Error("Keyring is not unlocked");
        }
        return service.setDuration(msg.duration);
    };
};
const handleStartAutoLockMonitoringMsg = (service) => {
    return () => {
        return service.startAppStateCheckTimer();
    };
};
//# sourceMappingURL=handler.js.map